import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import {
  CommandButton,
  DetailsListLayoutMode,
  MessageBar,
  MessageBarType,
  SelectionMode,
  Stack,
  StackItem,
  TextField,
} from '@fluentui/react';
import { Page } from '../Page';
import { CommandBar } from '../CommandBar';
import { Container } from '../Container';
import { coursesFields } from '../../enums/coursesFields';
import { coursesFilterables } from '../../enums/coursesFilterables';
import { manageSkillsPermission } from 'enums/permissions';
import DetailsListWithContextMenu from '../DetailsListWithContextMenu';
import { useFilterList } from '../../hooks/useFilterList';
import { useBreadcrumbs } from '../../providers/BreadcrumbsProvider';
import withAccess from 'hocs/withAccess';
import { useToast } from 'providers/ToastContextProvider';

import { getCoursesContextualMenu, useCourses } from 'hooks/useCourses';

export const ManageCourses: React.FC = () => {
  const history = useHistory();
  const { setBreadcrumbs } = useBreadcrumbs();
  const { courses = [] } = useCourses();
  const { toastSuccessMessage } = useToast();
  const menu = getCoursesContextualMenu();
  const [searchQuery, setSearchQuery] = useState('');
  const { filteredList } = useFilterList(courses, searchQuery);

  useEffect(() => {
    setBreadcrumbs([]);
  }, [history]);

  return (
    <Page>
      <CommandBar />
      <Container mt={-5}>
        <header>
          <h2>Manage Courses</h2>
          <CommandButton
            iconProps={{ iconName: 'Add' }}
            text="New Courses"
            onClick={() => history.push('/managecourses/new')}
          />
        </header>
        <Stack horizontal style={{ marginBottom: 16 }}>
          <StackItem>
            <TextField
              value={searchQuery}
              style={{ minWidth: 300 }}
              onChange={(_: any, value: any) => {
                setSearchQuery(value);
              }}
            />
          </StackItem>
        </Stack>
        {toastSuccessMessage && (
          <div style={{ marginBottom: 16 }}>
            <MessageBar
              messageBarType={MessageBarType.success}
              isMultiline={false}
            >
              {toastSuccessMessage}
            </MessageBar>
          </div>
        )}
        <div className="da-details-list-container">
          {courses && (
            <DetailsListWithContextMenu
              columns={coursesFields}
              items={filteredList}
              selectionMode={SelectionMode.none}
              onActiveItemChanged={(item) =>
                item && history.push(`/managecourses/${item.id}/edit`)
              }
              contextMenu={menu}
              filterableColumns={coursesFilterables}
              layoutMode={DetailsListLayoutMode.fixedColumns}
            />
          )}
        </div>
      </Container>
    </Page>
  );
};

export default withAccess(manageSkillsPermission, ManageCourses);
